import { useMemo } from 'react';

import { Modal } from '../../../UIPackage/ModalModule/components/Modal';
import { ModalHeader } from '../../../UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from '../../../UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from '../../../UIPackage/ModalModule/components/ModalActions';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import { ISelectOption, SelectInput } from '../../../UIPackage/MainModule/components/SelectInput';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { UploadFile } from '../../../UIPackage/MainModule/components/UploadFile';
import { useKnmDocumentAttachment } from '../../MainModule/hooks/useKnmDocumentAttachment';
import { IKnmAttachment } from '../../../APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IKnmMassCancel } from '../../../APIPackage/KnmModule/interfaces/IKnmMassCancel';

interface IKnmMassCancelDetailModalProps {
  visible: boolean;
  onClose: () => void;
  massCancel: IKnmMassCancel | null | undefined;
}

export const KnmMassCancelDetailModal = ({ visible, onClose, massCancel }: IKnmMassCancelDetailModalProps) => {
  const reasonSelectOption: ISelectOption<number> | undefined = useMemo(() => {
    if (massCancel?.reason?.id) {
      return {
        id: massCancel.reason.id,
        value: massCancel.reason.id,
        label: massCancel.reason.name,
      };
    }
  }, [massCancel]);

  const { downloadKnmDocumentAttachment } = useKnmDocumentAttachment();
  const downloadAttachment = (attachment: IKnmAttachment) => () => {
    const { fileName, fileSize, filePath, mimeType } = attachment;

    downloadKnmDocumentAttachment({ fileName, filePath, fileSize, mimeType });
  };

  return (
    <Modal visible={visible} onClose={onClose}>
      <ModalHeader title={`Группа мероприятий, подлежащих отмене №${massCancel?.groupId || ''}`} />
      <ModalBody size="content">
        <FieldBlock label="Основание массовой отмены" margin="bottom">
          <SelectInput value={reasonSelectOption} disabled />
        </FieldBlock>
        {massCancel?.reasonFile && (
          <FieldBlock label="Файл основания массовой отмены" color="black" margin="bottom">
            <UploadFile
              fileName={massCancel.reasonFile.fileName || ''}
              fileSize={massCancel.reasonFile.fileSize}
              onFileNameClick={downloadAttachment(massCancel.reasonFile)}
            />
          </FieldBlock>
        )}
      </ModalBody>
      <ModalActions>
        <Button text="Закрыть" size="medium" type="button" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
